const OrderHistory = ()=>{
    return(
        <div>order history</div>
    )
}

export default OrderHistory;